import React from 'react';
import { Modal } from 'antd';
import DocumentSharePanel from './DocumentSharePanel';

/**
 * Modal wrapper for share (link + QR). Controlled open state from parent.
 */
const DocumentShareModal = ({ open, onClose, variant }) => (
  <Modal
    title="Share"
    open={open}
    onCancel={onClose}
    footer={null}
    width={520}
    destroyOnClose
    styles={{ body: { paddingTop: 8 } }}
  >
    <DocumentSharePanel variant={variant} showHeading={false} />
  </Modal>
);

export default DocumentShareModal;
